import { render, staticRenderFns } from "./packages-form-modal.vue?vue&type=template&id=22fe4e58&scoped=true&"
import script from "./packages-form-modal.vue?vue&type=script&lang=js&"
export * from "./packages-form-modal.vue?vue&type=script&lang=js&"
import style0 from "./packages-form-modal.vue?vue&type=style&index=0&id=22fe4e58&lang=scss&scoped=true&"
import style1 from "./packages-form-modal.vue?vue&type=style&index=1&id=22fe4e58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fe4e58",
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QForm,QOptionGroup,QInput,QBtn,QSpinnerIos,QField} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QCardSection,QForm,QOptionGroup,QInput,QBtn,QSpinnerIos,QField})
